export type RecencyPreset = "1h" | "24h" | "7d" | "30d";

export const DEFAULT_RECENCY: RecencyPreset = "30d";

export const RECENCY_PRESETS: RecencyPreset[] = ["1h", "24h", "7d", "30d"];

export const RECENCY_MS: Record<RecencyPreset, number> = {
  "1h": 3_600_000,
  "24h": 86_400_000,
  "7d": 7 * 86_400_000,
  "30d": 30 * 86_400_000,
};

export const RECENCY_LABEL_KEY: Record<RecencyPreset, string> = {
  "1h": "MAP_RECENCY_1H",
  "24h": "MAP_RECENCY_24H",
  "7d": "MAP_RECENCY_7D",
  "30d": "MAP_RECENCY_30D",
};

export type MapPostsFilters = {
  recency: RecencyPreset;
  city: string | null;
  eventType: string | null;
};

export const recencyToDateFrom = (recency: RecencyPreset): Date =>
  new Date(Date.now() - RECENCY_MS[recency]);
